import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTrafficlightRed = ({ title, titleId, ...props }) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	viewBox: "0 0 130 330",
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsxs("defs", { children: [
			/* @__PURE__ */ _jsx("path", {
				id: "x",
				fill: "url(#h)",
				d: "M35 50a34 34 0 0 1 60 0q3 5 0 10-30 18-60 0-3-5 0-10z"
			}),
			/* @__PURE__ */ _jsxs("radialGradient", {
				id: "r",
				cx: .5,
				cy: .5,
				r: .5,
				fx: .5,
				fy: .5,
				children: [
					/* @__PURE__ */ _jsx("stop", {
						stopColor: "#fc7474",
						offset: 0
					}),
					/* @__PURE__ */ _jsx("stop", {
						stopColor: "#d53a3a",
						offset: .7
					}),
					/* @__PURE__ */ _jsx("stop", {
						stopColor: "#af0000",
						offset: 1
					})
				]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "k",
				x1: 0,
				x2: .4,
				y1: 0,
				y2: .9,
				children: [/* @__PURE__ */ _jsx("stop", {
					stopColor: "#5c656c",
					offset: 0
				}), /* @__PURE__ */ _jsx("stop", {
					stopColor: "#aab2b7",
					offset: 1
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "h",
				x1: 0,
				x2: 0,
				y1: 0,
				y2: 1.05,
				children: [
					/* @__PURE__ */ _jsx("stop", {
						stopColor: "#fff",
						stopOpacity: .9,
						offset: 0
					}),
					/* @__PURE__ */ _jsx("stop", {
						stopColor: "#fff",
						stopOpacity: .2,
						offset: .7
					}),
					/* @__PURE__ */ _jsx("stop", {
						stopColor: "#fff",
						stopOpacity: .3,
						offset: 1
					})
				]
			})
		] }),
		/* @__PURE__ */ _jsx("path", {
			fill: "url(#k)",
			stroke: "#000",
			strokeWidth: 10,
			d: "M5 5h120v320H5z"
		}),
		/* @__PURE__ */ _jsx("circle", {
			fill: "url(#r)",
			r: 40,
			cx: 65,
			cy: 65
		}),
		/* @__PURE__ */ _jsx("circle", {
			fill: "black",
			r: 40,
			cx: 65,
			cy: 165
		}),
		/* @__PURE__ */ _jsx("circle", {
			fill: "black",
			r: 40,
			cx: 65,
			cy: 265
		}),
		/* @__PURE__ */ _jsx("use", { xlinkHref: "#x" }),
		/* @__PURE__ */ _jsx("use", {
			xlinkHref: "#x",
			y: 100
		}),
		/* @__PURE__ */ _jsx("use", {
			xlinkHref: "#x",
			y: 200
		})
	]
});
export default SvgTrafficlightRed;
